import React, { FC } from "react";
import { Row, Col, Card, Progress } from "antd";
import { CaretDownFilled, CaretUpFilled, LineOutlined } from "@ant-design/icons";
import "./progress-card.scss";
import CustomTooltip from "@pages/tool-tip";
import { getProgressColorCode } from "@pages/utils/utils";
import { isEmpty, isUndefined } from "lodash";

const ProgressCard: FC<any> = (props) => {
  const floatValue = parseFloat(props?.percent?.replace('%',''))
  const status = floatValue === 0 ? 'same' : floatValue > 0 ? 'increase' : 'decrease'
  const statusDetails: any = {
    'same': {
      badgeClass: 'default-badge',
      icon: <LineOutlined />
    },
    'increase': {
      badgeClass: 'success-badge',
      icon: <CaretUpFilled />
    },
    'decrease': {
      badgeClass: 'error-badge',
      icon: <CaretDownFilled />
    }
  }[status]
  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "7px 8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );
  let _percent = props?.value ? props.value : 0;
  let _format = () => { return isUndefined(props.value) ? '0%' :  `${props.value}%` };

  if(!isEmpty( props.percentVal )) {
    _percent = props?.percentVal ? props.percentVal : 0;
    _format = () => props.value;
  }

  return (
    <Col span={props.size}>
      <Card style={{ height: props.cardHeight }} className="progress-card">
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: (props.cardHeight * 1) / 10,
            }}
            span={24}
          >
            {getHeading(props?.name)}
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: (props.cardHeight * 5) / 10,
            }}
            span={24}
          >
            <Progress
              type="circle"
              percent={_percent}
              format={_format}
              strokeColor={getProgressColorCode(props.scoreFlag)}
              className="progress-card__progress-bar" // adding this class, as the percentage is showing in green color when not needed @TaniaSharma
            />
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: (props.cardHeight * 2) / 10,
            }}
            span={24}
          >
            <span style={{ color: "#b3bac5", fontSize: "14px" }}>
              {props.scoreRange}
            </span>
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "baseline",
              height: (props.cardHeight * 2) / 10,
            }}
            span={24}
          >
            <span style={{ color: "#42526e", fontSize: "14px", marginRight:"5px" }}>
              {props.info}
            </span>
            <span className="clr-n125" style={{ margin: 0 , fontWeight:"normal"}}>
                                <span className={`status-badge ${statusDetails['badgeClass']}`}>
                                    {statusDetails['icon']}
                                    <span>{props?.percent}</span>
                                </span>
                                </span>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default ProgressCard;
